import { AppRouteRecordRaw } from '@/router/types'

export const workbenchConfiguration: AppRouteRecordRaw[] = [
  {
    path: 'workbenchConfiguration',
    name: 'WorkbenchConfiguration',
    component: () => import('@/views/workbenchConfiguration/index.vue'),
    meta: {
      title: '工作台配置'
    }
  }
]
